module.exports = __webpack_public_path__ + "static/media/driving-license.76bb3d74.png";